import type {
  BooleanField,
  ModifiedBooleanField
} from '@library/types/rulesets';
import { PrizepicksSwitch } from '@library/components/switches';

interface RuleSwitchProps {
  initialValue: BooleanField;
  modifiedValue: ModifiedBooleanField;
  active: boolean;
  disabled: boolean;
  handleChange: (value: boolean) => void;
}

export const RuleSwitch = ({
  initialValue,
  modifiedValue,
  active,
  disabled,
  handleChange
}: RuleSwitchProps) => {
  // Yellow state
  const isDifferentFromParentUnsaved = !!(
    initialValue.ancestor &&
    modifiedValue &&
    Object.hasOwn(modifiedValue, 'value') &&
    modifiedValue?.value !== initialValue.ancestor.value
  );
  const yellowOutline =
    modifiedValue && isDifferentFromParentUnsaved
      ? '!outline-spottieOttie outline-1 outline-offset-0 !focus:outline-spottieOttie focus:outline-1'
      : '';

  // Blue state
  const isDifferentFromParentSaved = !!(
    initialValue.ancestor &&
    Object.hasOwn(initialValue, 'value') &&
    initialValue?.value !== initialValue.ancestor?.value
  );
  const blueOutline =
    !modifiedValue && isDifferentFromParentSaved
      ? '!outline-msJackson outline-1 outline-offset-0 !focus:outline-msJackson focus:outline-1'
      : '';

  return (
    <PrizepicksSwitch
      active={active}
      handleChange={handleChange}
      disabled={disabled}
      className={`${yellowOutline} ${blueOutline}`}
    />
  );
};
